import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import fontConfig from '../../../Componentes/FontConfig';
import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Tooltip } from 'primereact/tooltip';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import { SpeedDial } from 'primereact/speeddial';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoEditar from '../../../Componentes/BotaoEditar';
import BotaoExcluir from '../../../Componentes/BotaoExcluir';
import { getDataRepository } from '../../../providers/Repository';
import DisplayStatusEquipamento from './Componentes/DisplayStatusEquipamento';
import { RadioButton } from 'primereact/radiobutton';
import SidebarColetas from './Componentes/SidebarColetas';
import TonerLevel from '../../../Componentes/TonerLevel';
import { Badge } from 'primereact/badge';
import { Slider } from "primereact/slider";
import SidebarDetalheColetas from './Componentes/SidebarDetalheColetas';
import { Chip } from 'primereact/chip';
import { Menu } from 'primereact/menu';
import SidebarFiltrosPrevisao from './Componentes/SidebarFiltrosPrevisao';
import { MultiSelect } from 'primereact/multiselect';




export default function VisaoPrevisoesToner(props) {
    const toast = React.useRef(null); // Ref para o Toast
    const [ingredient, setIngredient] = useState('parque');
    const [selectedCores, setSelectedCores] = useState(null);
    const [visible, setVisible] = useState(false);
    const [coleta, setColeta] = useState([])
    const [loading, setLoading] = useState(false);

    const [coletas, setColetas]= useState([]);
    
    const [selectedColetas, setSelectedColetas]= useState([]);
    
    const [selectAll, setSelectAll] = useState(false);

    const [fieldsFound, setFieldsFound] = useState([]);

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [parametroData, setParametroData] = useState(['',''])
    
    const location = useLocation();

    const { dataEmpresa } = location.state || {};

    const op = useRef(null); // Referência para o OverlayPanel
    const [openFilter, setOpenFilter] = useState(false)
    const requisicaoInicialData = useRef(false); // Referência para o botão de filtro

    const [totalRegistros, setTotalRegistros] = useState(0)
    const [diasPesquisa, setDiasPesquisa] = useState([0,999])
    const [faixaTonerCiano, setFaixaTonerCiano] = useState([0,100])
    const [faixaTonerMagenta, setFaixaTonerMagenta] = useState([0,100])
    const [faixaTonerAmarelo, setFaixaTonerAmarelo] = useState([0,100])
    const [faixaTonerPreto, setFaixaTonerPreto] = useState([0,100])
    const [verCorPreta, setVerCorPreta] = useState(true)
    const [verCorCiano, setVerCorCiano] = useState(true)
    const [verCorMagenta, setVerCorMagenta] = useState(true)
    const [verCorAmarelo, setVerCorAmarelo] = useState(true)
    const [dias, setDias] = useState([1, 365])
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        idempresa: { value: '', matchMode: FilterMatchMode.EQUALS },
        numeroserie: { value: '', matchMode: FilterMatchMode.CONTAINS },
        modelo: { value: '', matchMode: FilterMatchMode.CONTAINS },
        marca: { value: '', matchMode: FilterMatchMode.CONTAINS },
        cor: {
            operator: 'or',
            constraints: [
                { value: 'CIANO', matchMode: FilterMatchMode.EQUALS },
                { value: 'MAGENTA', matchMode: FilterMatchMode.EQUALS },
                { value: 'AMARELO', matchMode: FilterMatchMode.EQUALS },
                { value: 'PRETO', matchMode: FilterMatchMode.EQUALS }
            ]
        },
        dias: {
            operator: 'and',
            constraints: [
                { value: diasPesquisa[0], matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
                { value: diasPesquisa[1], matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO }
            ]
        }
        
    });
    
        useEffect(()=>{
            if(faixaTonerPreto[0] === 0 && faixaTonerPreto[1] === 100){
                return 
            }
            setFilters(prevFilters => ({
                ...prevFilters,
                nivel: {
                    operator: 'and',
                    constraints: [
                        { value: faixaTonerPreto[0], matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
                        { value: faixaTonerPreto[1], matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO }
                    ]
                },
            }));
        }, [faixaTonerPreto])

        useEffect(()=>{

            if(dias[0] === '' ||  dias[1] === ''){
                return 
            }
            setFilters(prevFilters => ({
                ...prevFilters,
                dias: {
                    operator: 'and',
                    constraints: [
                        { value: dias[0], matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
                        { value: dias[1], matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO }
                    ]
                },
            }));
            console.log(filters)
        }, [dias])


        useEffect(() => {
           
            const corConstraints = [];

            if (verCorCiano) corConstraints.push({ value: 'CIANO', matchMode: FilterMatchMode.EQUALS });
            if (verCorMagenta) corConstraints.push({ value: 'MAGENTA', matchMode: FilterMatchMode.EQUALS });
            if (verCorAmarelo) corConstraints.push({ value: 'AMARELO', matchMode: FilterMatchMode.EQUALS });
            if (verCorPreta) corConstraints.push({ value: 'PRETO', matchMode: FilterMatchMode.EQUALS });
        
            setFilters(prevFilters => ({
                ...prevFilters,
                cor: {
                    operator: 'or',
                    constraints: corConstraints.length > 0 ? corConstraints : [
                        { value: '---', matchMode: FilterMatchMode.EQUALS } // valor que não existe, bloqueia tudo
                    ]
                }
            }));
        }, [ verCorCiano, verCorMagenta, verCorAmarelo, verCorPreta]);
        

 useEffect(() => {
        if(!requisicaoInicialData.current){
            getData();
            requisicaoInicialData.current = true
        }else{

        }
        
    }, []);

    const getData = () => {
       
        clearFilters()

       setLoading(true)

        Conexao.post('coletasController/getPrevisaoFimToner', {
            idempresa : dataEmpresa.idempresa, 
            idcliente : dataEmpresa.idcliente ? dataEmpresa.idcliente : -1
        })
        .then(response => {

           if(response.status === 200 && response.data.status === 'OK'){

                console.log(response.data.payload)
                setColetas(response.data.payload)

           }else{

            setColetas([])

           }
           
            setLoading(false)

        }).catch(error => {
            
            setColetas([])

            setLoading(false);

            showMessageToast('error', "Não foi possível recuperar dados")
        });
    };

  
    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };


    const handleFilterChange = (e, field) => {

        const value = e.target.value;
        
        setFilters(prevFilters => ({
            ...prevFilters,
            [field]: { value, matchMode: FilterMatchMode.CONTAINS },
            
        }));
    };

    const [overlayVisible, setOverlayVisible] = useState(false);

    const handleFilterConfirm = () => {
        // Aqui você pode aplicar os filtros ao DataTable ou fazer outras ações necessárias
        setOverlayVisible(false); // Fecha o overlay após aplicar os filtros
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
    
        // Atualizar o filtro global
        const _filters = { ...filters };
        _filters['global'].value = value;
        
       
        setFilters(_filters);
    
        // Identificar os campos onde o filtro foi encontrado
      
    };
    
 
    const coresDisponiveis = [
        { name: 'CIANO', value: 'CIANO' },
        { name: 'MAGENTA', value: 'MAGENTA' },
        { name: 'AMARELO', value: 'AMARELO' },
        { name: 'PRETO', value: 'PRETO' }
      ];

    const renderHeader = () => {

        return (

            <React.Fragment>
                
            <div className="flex flex-wrap align-items-center" style={{paddingBottom : '10px', paddingTop : '10px', paddingLeft : '0px'}}>
                <div className="col-12 md:col-10">
                    <div className='col-12 md:col-4'>                            
                            <div  style={{marginBottom:'10px', fontSize: '12px',textAlign:'center'}}>Previsão em dia(s) (Tempo médio)</div>
                                <Slider 
                                    tooltip="Dias restante para o fim do suprimento" 
                                    tooltipOptions={{ position: 'bottom' }} 
                                    value={dias}
                                     onChange={(e) => setDias(e.value)} className="w-full " range min={1} max={365} />
                            <div className='texto-sm' style={{marginTop:'5px', fontSize: '10px',textAlign:'center'}}>Min: {dias[0]} - Max: {dias[1]}</div>
                        </div>
                    <div className="flex flex-wrap align-items-center gap-2">
                        <div className='col-12 md:col-3'>
                        <IconField iconPosition="left" className='w-full mt-2'>
                            <InputIcon className="pi pi-search" />
                            <InputText 
                                className='w-full '
                                value={globalFilterValue} 
                                onChange={onGlobalFilterChange} 
                                disabled = {loading}
                                placeholder="Pesquisa global" 
                                tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                            />
                            
                        </IconField>
                        </div>
                        
                        
                        <div className='col-12 md:col-1 pr-2 gap-0'>
                            <div className='flex justify-content-around align-items-center mt-2'>
                                <Button 
                                    icon="pi pi-filter-slash" 
                                    className="p-button-secondary p-button-sm" 
                                    onClick={clearFilters} 
                                    disabled = {loading}
                                    tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                                />
                        
                                <Button 
                                    icon="pi pi-sync" 
                                    className= "p-button-primary p-button-sm ml-2" 
                                    onClick={getData} 
                                    disabled = {loading}
                                    tooltip="Buscar dados..." tooltipOptions={{ position: 'bottom' }}
                                /> 
                            </div>
                          
                         </div>           
                                
                    </div>
                </div>
                <div className="col-12 md:col-2">
                    
                    <div className='p-0'>
                        <div className='texto-sm' style={{marginTop:'-10px', fontSize: '0.9rem',textAlign:'center', }}>Níveis e Cores</div>
                        <Slider style={{marginTop :'10px'}} value={faixaTonerPreto} onChange={(e) => setFaixaTonerPreto(e.value)} className="w-full " range />
                        <div className='texto-sm' style={{marginTop:'5px', fontSize: '10px',textAlign:'center'}}>Min: {faixaTonerPreto[0]} - Max: {faixaTonerPreto[1]}</div>
                    </div>
                    
                    <div className='flex justify-content-around align-items-center mt-4'>
                            <span 
                                className="text-xl  p-1 pl-3 pr-3" 
                                style={{backgroundColor : '#1E88E5', color: '#fff',cursor:'pointer', opacity : verCorCiano ? 1 : 0.2, }} 
                                onClick={()=>setVerCorCiano(!verCorCiano)}>C</span>

                            <span 
                                className="text-xl  p-1 pl-3 pr-3 ml-2" 
                                style={{backgroundColor : '#EC407A', color: '#fff', cursor:'pointer', opacity : verCorMagenta ? 1 : 0.2}}
                                onClick={()=>setVerCorMagenta(!verCorMagenta)}>M</span>

                            <span 
                                className="text-xl  p-1 pl-3 pr-3 ml-2" 
                                style={{backgroundColor : '#FFCA28', color: '#fff',cursor:'pointer', opacity : verCorAmarelo ? 1 : 0.2}}
                                onClick={()=>setVerCorAmarelo(!verCorAmarelo)}>Y</span>
                                
                            <span 
                                className="text-xl  p-1 pl-3 pr-3 ml-2" 
                                style={{backgroundColor : '#000', color: '#fff',cursor:'pointer', opacity : verCorPreta ? 1 : 0.2}}
                                onClick={()=>setVerCorPreta(!verCorPreta)}>K</span>
                    </div>
              
                </div>
                
            </div>

            </React.Fragment>

        );
    };
    

    const renderFooter = () => {
        if (fieldsFound.length === 0) {
            return  <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {totalRegistros} 
        </div>
        }
        
        return <>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {totalRegistros} 
        </div>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Filtro encontrado em: {fieldsFound.join(', ')}
        </div>
    </>
    };

    const clearFilters = () => {
        setGlobalFilterValue('');
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            idempresa: { value: '', matchMode: FilterMatchMode.EQUALS },
            numeroserie: { value: '', matchMode: FilterMatchMode.CONTAINS },
            modelo: { value: '', matchMode: FilterMatchMode.CONTAINS },
            marca: { value: '', matchMode: FilterMatchMode.CONTAINS },
            cor: {
                operator: 'or',
                constraints: [
                    { value: 'CIANO', matchMode: FilterMatchMode.EQUALS },
                    { value: 'MAGENTA', matchMode: FilterMatchMode.EQUALS },
                    { value: 'AMARELO', matchMode: FilterMatchMode.EQUALS },
                    { value: 'PRETO', matchMode: FilterMatchMode.NOT_EQUALS }
                ]
            },
            dias: {
                operator: 'and',
                constraints: [
                    { value: diasPesquisa[0], matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
                    { value: diasPesquisa[1], matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO }
                ]
            }
        });        
        setFieldsFound([]); // Resetando os campos encontrados
        setFaixaTonerPreto([0,100])
        setVerCorCiano(true)
        setVerCorMagenta(true)
        setVerCorAmarelo(true)
        setVerCorPreta(true)
        setDias([1,365])
    };



  
    
    const onSelectionChange = (event) => {
        const value = event.value;
        setSelectedColetas(value);

        // Atualiza o estado do botão "Selecionar Todos"
        const allSelected = coletas.every(c => value.some(s => s.idcoleta === c.idcoleta));
        setSelectAll(allSelected);
    };

    const onSelectAllChange = (event) => {
        const checked = event.checked;

        if (checked) {
            const newSelected = [
                ...coletas.filter(s => !coletas.some(c => c.idcoleta === s.idcoleta)),
                ...coletas
            ];
            setSelectedColetas(newSelected);
        } else {
            const remaining = selectedColetas.filter(s => !coletas.some(c => c.idcoleta === s.idcoleta));
            setSelectedColetas(remaining);
        }

        setSelectAll(checked);
    };

    
    return (
        <Layout loading={loading}>
            <div className="p-2">
              

                <div className="border-round-lg surface-card shadow-0 p-2">
                    {/* Botão para abrir o OverlayPanel */}
                    
                
                        <DataTable
                            header={renderHeader()}  
                            footer={renderFooter} 
                            value={coletas}
                            paginator 

                            totalRecords={coletas.length}             
                            rows={10} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            tableStyle={{ minWidth: '35rem' }}
                            filters={filters} // Aplicando os filtros
                            filterDisplay="menu" // Exibe os filtros como menu pop-up
  
                        >
                            
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '1%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                header="Nivel" 
                                field='nivel'   
                                sortable                          
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <>                               
                                <div className='flex-spacing' >
                                    <TonerLevel 
                                        width='25px'
                                        nivel={row.nivel} 
                                        cor={row.cor} />
                                                                                                                                                                              
                                </div>
                                </>
                                }
                                />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '3%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="numeroserieunidade" 
                                header="Nº Unidade" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <span>{row.numeroserieunidade}</span>
                                }
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar pelo serial" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '3%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="numeroserie" 
                                header="Serial" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <Tag severity="contrast" style={{cursor:'pointer'}} className='w-full' value={row.numeroserie} onClick={()=>{
                                    if(globalFilterValue === row.numeroserie){
                                        setColeta(row)
                                    }else{
                                        setGlobalFilterValue(row.numeroserie)
                                        setFilters(prevFilters => ({
                                                    ...prevFilters,
                                                      global: {
                                                          value: row.numeroserie,
                                                          matchMode: FilterMatchMode.CONTAINS // ou EQUALS, STARTS_WITH etc.
                                                    },
                                                }));
                                    }
                                  
                                }}></Tag>
                                }
                                sortable 
                                filter 
                                filterElement={(options) => (
                                                                    <InputText
                                                                        value={options.value}                                        
                                                                        onChange={(e) => options.filterCallback(e.target.value)}
                                                                        onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                                                        placeholder=""
                                                                        />
                                                                )} 
                                filterPlaceholder="Filtrar pelo serial" />
                             <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '6%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="marca" 
                                header="Marca" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <div>
                                    <span className='text-sm'>{row.marca}</span><br/>                            
                                </div>
                                }
                                sortable 
                                filter 
                                filterElement={(options) => (
                                                                    <InputText
                                                                        value={options.value}                                        
                                                                        onChange={(e) => options.filterCallback(e.target.value)}
                                                                        onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                                                        placeholder=""
                                                                        />
                                                                )} 
                                filterPlaceholder="Filtrar pela Marca" />
                                <Column 
                                    bodyStyle={{ fontSize: fontConfig.small , width : '10%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    field="modelo" 
                                    header="Equipamento" 
                                    body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                    <div>
                            
                                        <span className='text-sm'>{row.modelo}</span><br/>
                                    </div>
                                    }
                                    sortable 
                                    filter 
                                    filterPlaceholder="Filtrar pelo modelo" />

                                <Column     
                                    bodyStyle={{ fontSize: fontConfig.small , width : '3%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    field="dias" 
                                    header="Dias" 
                                    body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                    <div>
                                        <span  style={{fontSize :'0.7rem'}}>{row.dias2 ? 'entre '+ row.dias+' e '+row.dias2 +' dia(s)' :row.dias+' dia(s)' } </span><br/>
                                        
                                    </div>
                                    }
                                    sortable 
                                    filterPlaceholder="Filtrar pelo modelo" />
                                <Column     
                                    bodyStyle={{ fontSize: fontConfig.small , width : '2%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    field="data_prevista" 
                                    header="Data 1" 
                                    body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                    <div>
                            
                                        <span className='text-sm'>{row.data_prevista}</span><br/>
                                    </div>
                                    }
                                    sortable 
           
                                    filterPlaceholder="Filtrar pelo modelo" />
                                <Column     
                                    bodyStyle={{ fontSize: fontConfig.small , width : '2%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    field="data_prevista2" 
                                    header="Data 2" 
                                    body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                    <div>
                            
                                        <span className='text-sm'>{row.data_prevista2}</span><br/>
                                    </div>
                                    }
                                    sortable 
                                   
                                    filterPlaceholder="Filtrar pelo modelo" />
                                <Column     
                                    bodyStyle={{ fontSize: fontConfig.small , width : '5%', paddingTop : '2px', paddingBottom : '2px' }} 
                                    headerStyle={{ fontSize: fontConfig.small }} 
                                    field="consumomedio" 
                                    header="Consumo Médio" 
                                    body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                    <div>
                            
                                        <span className='text-sm'>{row.consumomedio ? row.consumomedio.toFixed(2)+'% por dia' : '* desconhecido'}</span><br/>
                                    </div>
                                    }
                                    sortable 
                                  
                                    filterPlaceholder="Filtrar pelo modelo" />
                                
                        </DataTable>
                    
                </div>                
            </div>

            <OverlayPanel ref={op} style={{ width: '300px' }}>
                    <div className="p-3">
                        <h4>Filtros</h4>
                        
                       
                        <div className="p-field">
                            <label htmlFor="cor">COR</label>
                            <InputText
                                id="cor"
                                value={filters.cor.value}
                                onChange={(e) => handleFilterChange(e, 'cor')}
                            />
                        </div>
                        

                     

                        <div className="p-field">
                            <label htmlFor="razaosocial">Marca</label>
                            <InputText
                                id="marca"
                                value={filters.marca.value}
                                onChange={(e) => handleFilterChange(e, 'marca')}
                            />
                        </div>

                        <div className="p-field">
                            <label htmlFor="razaosocial">Modelo</label>
                            <InputText
                                id="modelo"
                                value={filters.modelo.value}
                                onChange={(e) => handleFilterChange(e, 'modelo')}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="razaosocial">Dias</label>
                            <InputText
                                id="dias"
                                value={filters.dias.value}
                                onChange={(e) => handleFilterChange(e, 'modelo')}
                            />
                        </div>

                        <Button label="Aplicar Filtro" icon="pi pi-check" onClick={handleFilterConfirm} />
                    </div>
                </OverlayPanel>
             <Toast ref={toast} />
             <SidebarFiltrosPrevisao 
                openFilter ={openFilter} 
                setOpenFilter={setOpenFilter }
                verCorCiano={verCorCiano}
                setVerCorCiano={setVerCorCiano}
                verCorMagenta={verCorMagenta}
                setVerCorMagenta={setVerCorMagenta}
                verCorAmarelo={verCorAmarelo}
                setVerCorAmarelo={setVerCorAmarelo}
                verCorPreta={verCorPreta}
                setVerCorPreta={setVerCorPreta}
                faixaTonerPreto={faixaTonerPreto}
                setFaixaTonerPreto={setFaixaTonerPreto}
                parametroData = {parametroData}
                setParametroData ={setParametroData}
                />
            <SidebarDetalheColetas 
                coleta = {coleta}
                setColeta = {()=>setColeta([])}/>
        </Layout>
    );
}
